import { useSelector } from "react-redux";
import PanelLayout from "../../../layouts/PanelLayout";
import { RiFolderDownloadLine } from "react-icons/ri";
import AppContext from "../../../AppContext";
import React, { useState } from "react";
import { Container, Table, Button, Card, Modal } from "react-bootstrap";

function FacturasList() {
  const ctacte = useSelector((state) => state.ctacte);
  const baseApiUrl = `${AppContext.baseApiUrl}/${AppContext.urlServiceFactura}`;
  const [mostrarModal, setMostrarModal] = useState(false);
  const [cuotaSeleccionada, setCuotaSeleccionada] = useState(null);

  const procesarMovimientos = (items, tipo) => {
    const hoy = new Date();
    const mesActual = hoy.getMonth();
    const mesLimite = mesActual + 1;

    return items
      .filter(
        (item) =>
          Number(item.mes) !== 0 &&
          (Number(item.debe || 0) > 0 || Number(item.interes || 0) > 0)
      )
      .map((mov) => {
        const pagoRelacionado = ctacte.find(
          (p) =>
            (p.codcomprobante === "FC" || p.codcomprobante === "FE") &&
            Number(p.idInternoComprobantePagado) ===
              Number(mov.idInternoComprobante)
        );

        const pagado = !!pagoRelacionado;
        const fechaMostrar = pagoRelacionado
          ? new Date(pagoRelacionado.fecha)
          : new Date(mov.fecha);

        const debe = pagado
          ? Number(mov.debe || 0)
          : Number(mov.debe || 0) + Number(mov.interes || 0);

        return {
          idctacte: mov.idctacte,
          fecha: fechaMostrar,
          anio: mov.anio,
          mes: mov.mes,
          detalle: mov.detalle,
          debe,
          pagado,
          idInternoComprobante: mov.idInternoComprobante,
          llave: pagoRelacionado?.llave || null,
          nrofactura: pagoRelacionado?.nrofactura || null,
          tipo,
        };
      })
     .filter((item) => {
  const fechaItem = new Date(item.fecha);

  const hoy = new Date();

  const fechaDesde = new Date(
    hoy.getFullYear(),
    hoy.getMonth() - 6,
    1
  );

  const fechaHasta = new Date(
    hoy.getFullYear(),
    hoy.getMonth() + 1,
    31
  );

  return fechaItem >= fechaDesde && fechaItem <= fechaHasta;
});

  };

  const cuotas = procesarMovimientos(
    ctacte.filter((i) => i.codcomprobante === "C"),
    "Cuota"
  );

  const matriculas = procesarMovimientos(
    ctacte.filter((i) => i.codcomprobante === "M"),
    "Matrícula"
  );

  const todosLosMovimientos = [...cuotas, ...matriculas].sort((a, b) => {
    if (a.pagado !== b.pagado) return a.pagado ? 1 : -1;
    return b.fecha - a.fecha;
  });

  return (
    <PanelLayout>
      <Container className="mb-5">
        <div className="border-bottom mb-3">
          <h1 className="h4 fw-bold text-black">Cuotas y Matrículas</h1>
        </div>

        {/* 🖥️ Versión de escritorio */}
        <div className="scroll-horizontal d-none d-md-block shadow-lg" data-aos="fade-up">
          <Table hover responsive bordered={false} className="align-middle text-nowrap shadow-lg mb-0">
            <thead className="table-light">
              <tr>
                <th>Fecha</th>
                <th>Periodo</th>
                <th>Detalle</th>
                <th>Tipo</th>
                <th>N° Factura</th>
                <th>Importe</th>
                <th>Estado</th>
                <th className="text-end">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {todosLosMovimientos.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center text-muted py-4">
                    No hay registros dentro del rango.
                  </td>
                </tr>
              ) : (
                todosLosMovimientos.map((item) => (
                  <tr key={item.idctacte}>
                    <td>{item.fecha.toLocaleDateString("es-AR")}</td>
                    <td>
                      {item.anio} / {item.mes}
                    </td>
                    <td>{item.detalle}</td>
                    <td>{item.tipo}</td>
                    <td>{item.nrofactura}</td>
                    <td>${item.debe.toLocaleString()}</td>
                    <td>
                      <span className={item.pagado ? "text-success fw-bold" : "text-danger fw-bold"}>
                        {item.pagado ? "PAGADA" : "PENDIENTE"}
                      </span>
                    </td>
                    <td className="text-end">
                      {item.pagado ? (
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() => window.open(`${baseApiUrl}/${item.llave}`, "_blank")}
                          disabled={!item.llave}
                        >
                          Descargar <RiFolderDownloadLine size={18} />
                        </Button>
                      ) : (
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() => {
                            setCuotaSeleccionada(item);
                            setMostrarModal(true);
                          }}
                        >
                          Pagar
                        </Button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>

        {/* 📱 Versión para celulares */}
        <div className="d-md-none">
          {todosLosMovimientos.length === 0 ? (
            <p className="text-center text-muted py-4">No hay registros dentro del rango.</p>
          ) : (
            todosLosMovimientos.map((item) => (
              <Card key={item.idctacte} className="mb-3 shadow-sm border-0">
                <Card.Body>
                  <h6 className="card-title fw-bold text-primary">
                    {item.tipo} - {item.detalle}
                  </h6>
                  <p className="mb-1">
                    <strong>Fecha:</strong> {item.fecha.toLocaleDateString("es-AR")}
                  </p>
                  <p className="mb-1">
                    <strong>Periodo:</strong> {item.anio} / {item.mes}
                  </p>
                  <p className="mb-1">
                    <strong>Factura:</strong> {item.nrofactura || "—"}
                  </p>
                  <p className="mb-1">
                    <strong>Importe:</strong> ${item.debe.toLocaleString()}
                  </p>
                  <p className="mb-2">
                    <strong>Estado:</strong>{" "}
                    <span className={item.pagado ? "text-success fw-bold" : "text-danger fw-bold"}>
                      {item.pagado ? "PAGADA" : "PENDIENTE"}
                    </span>
                  </p>
                  {item.pagado ? (
                    <Button
                      size="sm"
                      variant="outline-primary"
                      className="w-100"
                      onClick={() => window.open(`${baseApiUrl}/${item.llave}`, "_blank")}
                      disabled={!item.llave}
                    >
                      Descargar Factura <RiFolderDownloadLine size={18} />
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      variant="outline-primary"
                      className="w-100"
                      onClick={() => {
                        setCuotaSeleccionada(item);
                        setMostrarModal(true);
                      }}
                    >
                      Pagar
                    </Button>
                  )}
                </Card.Body>
              </Card>
            ))
          )}
        </div>
      </Container>

      {/* Modal de pago */}
      <Modal show={mostrarModal && !!cuotaSeleccionada} onHide={() => setMostrarModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Datos para el pago</Modal.Title>
        </Modal.Header>
        <Modal.Body className="fs-6">
          <p>
            <strong>Banco:</strong> Galicia
          </p>
          <p>
            <strong>Titular:</strong> FUNDACION COLEGIO SANTO TOMAS
          </p>
          <p>
            <strong>CBU:</strong> 0070251720000002576217
          </p>
          <p>
            <strong>CUIT:</strong> 30-70777161-1
          </p>
          <p>
            <strong>Alias:</strong> colegiosantotomas.g
          </p>
          <p>
            <strong>Monto:</strong> ${cuotaSeleccionada?.debe.toLocaleString()}
          </p>
          <p>
            <strong>Detalle:</strong> {cuotaSeleccionada?.detalle}
          </p>
          <p className="text-danger fw-bold">
            Si desea hacer una transferencia, por favor informar vía mail o WhatsApp para poder acreditar el pago.
          </p>
          <p>
            <strong>Tel:</strong> 2954-313911
          </p>
          <p>
            <strong>Mail:</strong> administracion@fundacioncolegiosantotomas.com.ar
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </PanelLayout>
  );
}

export default FacturasList;
